import { EditionId } from 'src/app/models';

export function assignIconEditionIds<T extends { icon?: string | null }>(
  icons: T[],
  subscriptionIds: number[],
  editionDate: number
): Array<{ editionId: number; icon: string | null }> {
  return subscriptionIds.map((subscriptionId, index) => ({
    editionId: EditionId.fromYearMonth(subscriptionId, editionDate),
    icon: icons[index]?.icon ?? null
  }));
}
